import "./CartSubtitle.css";
import React from "react";
import {
  FinancialData,
  ItemDetailsData,
} from "../../../../Utils/DefinitionsInterfaces";
import Cart from "../Cart/Cart";
import FormCluster from "../FormCluster/FormCluster";
import FormCluster2 from "../FormCluster/FormCluster2";
import { doNFOTransactionResponse } from "../../../../Utils/CheckoutAPIs/CheckoutAPIs";

interface CartSubtitleProps {
  stateDefaultItems: FinancialData[];
  stateCheckoutItems: ItemDetailsData[];
  cbRemoveProduct: (itemId: number) => void;
  cbHandlePaymentClick: (data?: doNFOTransactionResponse) => void;
}

const CartSubtitle = (props: CartSubtitleProps) => {
  return (
    <div className="cart-parent-wrapper">
      <div className="cart-subtitle">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FormCluster2 />
          <div className="delivery-address-title">
            <div className="delivery-address-title-text">Delivery Address</div>
            <div className="line-divider"></div>
          </div>

          <FormCluster />
        </div>
        <div className="outer-container">
          <div className="inner-divider"></div>
        </div>

        <Cart
          stateDefaultItems={props.stateDefaultItems}
          stateCheckoutItems={props.stateCheckoutItems}
          cbRemoveProduct={props.cbRemoveProduct}
          cbHandlePaymentClick={props.cbHandlePaymentClick}
        />
      </div>
    </div>
  );
};

export default CartSubtitle;
